import { ClassConstructor, plainToInstance } from "class-transformer";

import { VueComponent } from "../../../../../../shared/types/VueComponent";
import { PostActionTypeEnum } from "../../../types";
import { PostActionBuilder } from "../PostActionBuilder";
import { PostActionStructure } from "../PostActionStructure";
import UnpinChatMessageActionModel from "./UnpinChatMessageActionModel";

export default class UnpinChatMessageActionBuilder extends PostActionBuilder {
    type = PostActionTypeEnum.UnpinChatMessageAction;

    icon = 'near_me_disabled'

    view: VueComponent | undefined;
    valueView: VueComponent | undefined;

    createAction(constructor: ClassConstructor<PostActionStructure>): PostActionStructure {
      return plainToInstance(constructor, { action: new UnpinChatMessageActionModel() } )
    }
}
